import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';

import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';

import { getResponse, toastApiError } from '../../common';
import { API_URLS, queryClient } from '../../query.client';

export type DeleteAssetUserSuccessResponse = {
	id: string;
	message: string;
};

export async function deleteAssetUser({
	assetId,
	id,
}: {
	assetId: string;
	id: string;
}): Promise<DeleteAssetUserSuccessResponse | null> {
	const response = await axios.delete(`${API_URLS.ASSETS.USERS(assetId)}/${id}`);
	return getResponse<DeleteAssetUserSuccessResponse>(response.data);
}

export const useMutationRemoveAssetUser = () => {
	return mutationOptions({
		mutationFn: ({ assetId, id }: { assetId: string; id: string }) => deleteAssetUser({ assetId, id }),
		onSuccess: async (_data, variable) => {
			toast.success(t('assets.users.removeSuccess'));
			await queryClient.invalidateQueries({
				queryKey: ['assets', variable.assetId, 'users'],
			});
		},
		onError: (error) => toastApiError(error),
	});
};
